import type { Story } from '@/store/story-types'

export const AGENCY_STUDIO_STORY: Story = {
  id: 'agency-studio-1',
  name: 'Agency Studio',
  narrative: 'A creative agency portfolio with glassmorphism design, showcasing services, past work, and a contact entry point to convert potential clients.',
  goals: ['Present agency brand', 'Showcase services', 'Display portfolio work', 'Generate client inquiries'],
  lifecycle: 'building',
  pages: [
    { id: 'pg-home', title: 'Home', order: 0, status: 'draft', elementCount: 5, linkedPageId: 'agency-home', description: 'Single-page agency site with navbar, hero, services, portfolio, and footer',
      blockRef: { category: 'agency', blockId: 'hero-skew' } },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'View Portfolio',
      description: 'Visitor sees the agency hero and portfolio',
      steps: [
        { type: 'given', text: 'the visitor opens the agency website' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'the hero section with agency tagline and CTA is visible', linkedPageId: 'agency-home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Explore Services',
      description: 'Visitor browses the services offered',
      steps: [
        { type: 'given', text: 'the visitor is on the agency homepage' },
        { type: 'when', text: 'they scroll to the services section' },
        { type: 'then', text: 'service cards with titles, descriptions, and icons are displayed', linkedPageId: 'agency-home' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Browse Work',
      description: 'Visitor views past project showcases',
      steps: [
        { type: 'given', text: 'the visitor is on the agency homepage' },
        { type: 'when', text: 'they scroll to the portfolio section' },
        { type: 'then', text: 'project cards with images and case study details are shown', linkedPageId: 'agency-home' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Contact Agency',
      description: 'Visitor initiates a contact inquiry',
      steps: [
        { type: 'given', text: 'the visitor wants to hire the agency' },
        { type: 'when', text: 'they click the contact CTA in the footer' },
        { type: 'then', text: 'a contact form or email link is presented', linkedFlowId: 'contactAgency' },
      ],
    },
  ],
}
